import { toast } from "react-toastify";
import firebase from "../../config/firebase";

const questionLoader = (data) => async (dispatch) => {
  dispatch({
    type: "QUESTION_LOADER",
    payload: data
  });
};
const addLoader = (data) => async (dispatch) => {
  dispatch({
    type: "ADD_LOADER",
    payload: data
  });
};

export const updateCheckoutQuestion = (question) => async (dispatch) => {
  try {
    const updateBatch = firebase.firestore().batch();
    question?.forEach((item) => {
      const docRef = firebase
        .firestore()
        .collection("checkoutQuestions")
        .doc(item.id);
      updateBatch.update(docRef, {
        ...item
      });
    });
    await updateBatch.commit();
  } catch (error) {
    toast.error(error.message);
  } finally {
  }
};

export const getCheckoutQuestion =
  (restaurantID, filter) => async (dispatch) => {
    dispatch(questionLoader(true));

    try {
      let query = firebase
        .firestore()
        .collection("checkoutQuestions")
        .where("restaurantID", "==", restaurantID);

      if (filter) {
        query = query.where("type", "==", filter).orderBy("position", "asc");
      } else {
        query = query.orderBy("position", "asc");
      }

      query.onSnapshot((snapshot) => {
        let temp = [];
        snapshot.docs.forEach((doc) => {
          temp.push({
            id: doc.id,
            ...doc.data()
          });
        });

        dispatch({ type: "GET_QUESTION", payload: temp });
        dispatch(questionLoader(false));
      });
    } catch (error) {
      console.error("Error fetching checkout questions:", error.message);
      toast.error("Error fetching questions: " + error.message);
      dispatch(questionLoader(false));
    }
  };

export const getCheckoutResponses = (Id) => async (dispatch) => {
  dispatch(responseLoading(true));
  try {
    const querySnapshot = await firebase
      .firestore()
      .collection("checkoutResponses")
      .where("questionId", "==", Id)
      .orderBy("createdAt", "desc")
      .get();

    let responses = [];
    if (!querySnapshot.empty) {
      querySnapshot.docs.forEach((doc) => {
        responses.push({
          id: doc.id,
          ...doc.data()
        });
      });
    }
    dispatch({ type: "GET_RESPONSES", payload: responses });
  } catch (error) {
    console.error("Error fetching responses:", error.message);
    toast.error("Error fetching responses: " + error.message);
  } finally {
    dispatch(responseLoading(false));
  }
};

const responseLoading = (data) => async (dispatch) => {
  dispatch({
    type: "RESPONSE_LOADER",
    payload: data
  });
};

export const addCheckoutQuestion = (obj, onSuccess) => async (dispatch) => {
  dispatch(addLoader(true));
  firebase
    .firestore()
    .collection("checkoutQuestions")
    .add(obj)
    .then(() => {
      dispatch(addLoader(false));
      toast.success("Question Added Successfully");
      onSuccess();
    })
    .catch((err) => {
      toast.error(err.message);
      dispatch(addLoader(false));
    });
};

export const deleteQuestion =
  (id, onSuccess = () => {}) =>
  async (dispatch) => {
    dispatch(deleteLoader(true));
    await firebase
      .firestore()
      .collection("checkoutQuestions")
      .doc(id)
      .delete()
      .then(() => {
        firebase
          .firestore()
          .collection("checkoutResponses")
          .where("questionId", "==", id)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              doc.ref.delete();
            });
            dispatch(deleteLoader(false));
            onSuccess();
            toast.success("Feedback deleted Successfully");
          });
      })
      .catch((err) => {
        toast.error(err.message);
        dispatch(deleteLoader(false));
      });
  };
export const deleteLoader = (val) => async (dispatch) => {
  dispatch({
    type: "DELETE_LOADER",
    payload: val
  });
};

export const editCheckoutQuestion =
  (payload, onSuccess = () => {}) =>
  async (dispatch) => {
    dispatch(editLoader(true));
    const { id, ...restPayload } = payload;
    await firebase
      .firestore()
      .collection("checkoutQuestions")
      .doc(id)
      .update({
        ...restPayload
      })
      .then(() => {
        dispatch(editLoader(false));
        onSuccess();
        toast.success("Feedback Updated Successfully");
      })
      .catch((err) => {
        toast.error(err.message);
        dispatch(editLoader(false));
      });
  };

export const editLoader = (val) => async (dispatch) => {
  dispatch({
    type: "EDIT_LOADER",
    payload: val
  });
};
